/**
 * ローディング画面コンポーネント
 *
 * アプリケーションの読み込み中に表示
 */

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        {/* Thothアイコン */}
        <img
          src="/knovelo-trans-icon.png"
          alt="KnoVelo"
          className="w-24 h-24 mx-auto mb-6 animate-pulse"
        />

        {/* ローディングスピナー */}
        <div className="flex items-center justify-center gap-2 text-gray-500">
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>

        {/* テキスト */}
        <p className="mt-4 text-gray-500 text-sm">
          読み込み中...
        </p>
      </div>
    </div>
  );
}

export default LoadingScreen;
